<template>
  <div>
    <!-- 年检/季检登记 -->
    <div class="page_header">
      <span class="page_title" style="flex:1;text-align: left;">{{$t("maintenance.NextCheckTime_YQ_registration")}}</span>
      <el-form inline>
        <el-form-item :label="$t('vehicle.carNo') + '：' ">
          <el-input v-model="inputCarNo" :placeholder="$t('vehicle.carNoPls')" :size="size" clearable></el-input>
        </el-form-item>
        <el-form-item >
          <el-button 
            :size="size"
            type="primary" 
            style="margin-left:10px"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="page_container">
      <el-table :data="ListData" border :size="size">
        <el-table-column :label="$t('maintenance.basicInfo')"  align="center">
          <el-table-column :label="$t('vehicle.carNo')" align="center" prop="carNo" min-width="105"></el-table-column>
        </el-table-column>
        <el-table-column :label="$t('maintenance.inspect_annually')" align="center">
          <el-table-column :label="$t('maintenance.inspection_start')" align="center" prop="Y_BeginCheckTime" min-width="100"></el-table-column>
          <el-table-column :label="$t('maintenance.inspection_end')" align="center" prop="Y_NextCheckTime" min-width="100"></el-table-column>
          <el-table-column :label="$t('maintenance.OPTName')" align="center" prop="Y_OPTName" min-width="100"></el-table-column>
          <el-table-column :label="$t('public.Operation')" align="center" min-width="195">
            <template slot-scope="scope">
              <div style="font-size:12px">
                <el-link :underline="false" style="margin-right:10px;color:green" @click="add(scope.row,'Y')">
                  <i class="el-icon-plus" style="height: 16px;width:16px;font-weight:bold"></i> {{scope.row.Y_NextCheckTime ? $t('public.edit') : $t('public.newbuilt')}}</el-link>
                <el-link :underline="false" style="margin-right:10px;color:red" @click="del(scope.row,'Y')">
                  <i class="iconfont icon-icon_operat_delete" style="height: 16px;width:16px"></i> {{$t('public.del')}}</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('maintenance.Seasonal_inspection')" align="center">
          <el-table-column :label="$t('maintenance.inspection_start')" align="center" prop="Q_BeginCheckTime" min-width="100"></el-table-column>
          <el-table-column :label="$t('maintenance.inspection_end')" align="center" prop="Q_NextCheckTime" min-width="100"></el-table-column>
          <el-table-column :label="$t('maintenance.OPTName')" align="center" prop="Q_OPTName" min-width="100"></el-table-column>
          <el-table-column :label="$t('public.Operation')" align="center" min-width="195">
            <template slot-scope="scope">
              <div style="font-size:12px">
                <el-link :underline="false" style="margin-right:10px;color:green" @click="add(scope.row,'Q')">
                  <i class="el-icon-plus" style="height: 16px;width:16px;font-weight:bold"></i> {{scope.row.Q_NextCheckTime ? $t('public.edit') : $t('public.newbuilt')}}</el-link>
                <el-link :underline="false" style="margin-right:10px;color:red" @click="del(scope.row,'Q')">
                  <i class="iconfont icon-icon_operat_delete" style="height: 16px;width:16px"></i> {{$t('public.del')}}</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination
      :total="total"
      :currentPage="currentPage"
      @current-change="currentchange"
    ></kl-pagination>
    <div>
      <el-dialog class="dialog" :title="$t('maintenance.NextCheckTime_YQ')" :visible.sync="dialogY_Q" :width="(LanguageId  == 1 ||LanguageId  == 2) ? '450px' : '600px'" append-to-body :close-on-click-modal="false">
        <el-form ref="form" :model="dialog" :rules="rules"  label-width="130px" :label-position="LanguageId == 1 ? 'right' : 'top'">
          <el-form-item :label="$t('vehicle.carNo') + '：' ">
            <el-select :size="size" v-model="dialog.selCarNo" placeholder="" disabled>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('maintenance.NextCheckTime_YQ') + '：' ">
            <el-select :size="size" v-model="dialog.inspectionFlag" placeholder="">
              <el-option :label="$t('maintenance.inspect_annually')" value="1"></el-option>
              <el-option :label="$t('maintenance.Seasonal_inspection')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('maintenance.time') + '：' " prop="daterange">
            <el-date-picker :size="size" :style="{width:LanguageId == 1 ? '250px' : '290px'}"
              v-model="dialog.daterange"
              type="daterange"
              :range-separator="$t('time.to')"
              :start-placeholder="$t('time.startTime')"
              :end-placeholder="$t('time.endTime')"
              :clearable="false">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitSave">{{$t('public.save')}}</el-button>
        </span></el-dialog>
    </div>
  </div>
</template>
<script>
import Enrollment from '../components/enrollment.vue'
import language from '@/utils/getLanguageId'
import { mapState } from "vuex";
export default {
  data(){
    var validateDate = (rule, value, callback) => {
      // console.log(value);
      if (value === "") {
        callback(new Error(this.$t('maintenance.Select_time_range')));
      }else if(value == null || value == undefined){
        callback(new Error(this.$t('maintenance.Select_time_range')));
      } else if(value.length == 0){
         callback(new Error(this.$t('maintenance.Select_time_range')));
      }else{
        callback();
      }
    };
    return{
      rules:{
        daterange: [
          {  required: true, validator: validateDate, trigger: "change" },
        ]
      },
      selectRow:undefined,
      total:0,
      currentPage:1,
      dialog:{
        selCarNo:"",
        daterange:[],
        inspectionFlag:"1",
      },
      dialogY_Q:false,
      inputCarNo:"",
      ListData:[
        {"carNo": "11"}
      ],
      LanguageId:1,
    }
  },
  props:{},
  components:{Enrollment},
  computed:{
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      operator: (state) => state.user.operator,
      appVehicles: state => state.app.vehicles,
    }),
  },
  methods:{
    currentchange(page){
      this.currentPage = page;
      this.getList();
    },
    getList(){
      this.$api.inspectionY_QInfo({
        vehicle: this.inputCarNo,
        CompanyID: this.operator.CompanyId,
        // CompanyID: 5657,
        PageNo: this.currentPage,
        PageSize: 10,
        OperatorID: this.$store.getters.operator.OperatorId,
      })
      .then((res) => {
        if(res && res.code == 200){
          this.ListData = res.data;
          this.total = res.count;
        }
      })
      .catch((err) => {
        
      });
    },
    submitSave(){
      let beginDate = "";
      let endDate = "";
      let nextCheckTimeTemp = "";
      let Flag = 0;
      if(this.dialog.inspectionFlag == "1"){
        beginDate = this.moment(this.dialog.daterange[0]).format("YYYY-MM-DD");
        endDate = this.moment(this.dialog.daterange[1]).format("YYYY-MM-DD");
        nextCheckTimeTemp = this.selectRow.Y_NextCheckTime ? this.selectRow.Y_NextCheckTime : "";
        Flag = this.selectRow.Y_NextCheckTime ? 1 : 0;
      }else{
        beginDate = this.moment(this.dialog.daterange[0]).format("YYYY-MM-DD")
        endDate = this.moment(this.dialog.daterange[1]).format("YYYY-MM-DD")
        nextCheckTimeTemp = this.selectRow.Q_NextCheckTime ? this.selectRow.Q_NextCheckTime : "";
        Flag = this.selectRow.Q_NextCheckTime ? 1 : 0;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if((this.dialog.daterange == null || this.dialog.daterange == undefined || this.dialog.daterange.length == 0)){
            this.$message.info(this.$t('maintenance.Select_time_range'));
            return;
          }
          this.$api.inspectionY_QAdd({
            VehicleID: this.selectRow.VehicleID,
            checkFlag: this.dialog.inspectionFlag,
            beginDate: beginDate,
            endDate: endDate,
            OperatorID: this.operator.OperatorId,
            nextCheckTimeTemp: nextCheckTimeTemp,
            Flag: Flag,
          })
          .then((res)=>{
            if(res && res.code == 200){
              this.getList();
              this.dialogY_Q = false;
              this.selectRow = "";
            }
          })
        } else {
        }
      });
      
    },
    handleQuery(){
      this.currentPage = 1;
      this.getList();
    },
    add(row,y_Q){
      this.dialogY_Q = true;
      // console.log(row);
      this.selectRow = row;
      this.dialog.selCarNo = row.carNo;
      if(y_Q == "Y"){
        this.dialog.inspectionFlag = "1";
        this.dialog.daterange = row.Y_NextCheckTime ? [row.Y_BeginCheckTime,row.Y_NextCheckTime] : "";
      }else{
        this.dialog.inspectionFlag = "2";
        this.dialog.daterange = row.Q_NextCheckTime ? [row.Q_BeginCheckTime,row.Q_NextCheckTime] : "";
      }
    },
    del(row,Y_Q){
      // this.dialogY_Q = true;
      if(Y_Q == "Y" && row.Y_NextCheckTime == null) {
        this.$message.info(this.$t('statistics.noData'));
        return;
      }
      if(Y_Q == "Q" && row.Q_NextCheckTime == null) {
        this.$message.info(this.$t('statistics.noData'));
        return;
      }
      this.$confirm(
        this.$t('maintenance.confirmDelete'),
        "",
        {
          confirmButtonText: this.$t('public.confirm'),
          cancelButtonText: this.$t('public.cancel'),
          type: "warning",
        }
      )
      .then(() => {
        this.$api.inspectionY_QDel({ 
          VehicleID: row.VehicleID,
          checkFlag: Y_Q == "Y" ? 1 : 2,
          endDate: Y_Q == "Y" ? row.Y_NextCheckTime : row.Q_NextCheckTime,
        }).then((res) => {
          if (res && res.code == 200) {
            this.getList();
            this.$message.success(this.$t('public.hasDeleted'));
          } else {
            this.$message.warning(res.message);
          }
        });
      })
      .catch(() => {});
    },
  },
  mounted(){
    this.LanguageId = language(this.$store.getters.locale)
    this.getList();
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
 
</style>